{
  "sessionExpired": "Mae eich sesiwn wedi dod i ben - mewngofnodwch eto",
  "codeVerified": "Mae eich cod wedi'i ddilysu",
  "passwordChanged": "Mae eich cyfrinair wedi'i newid",
  "accountCreated": "Mae eich cyfrif wedi'i greu",
  "accountDeleted": "Mae eich cyfrif wedi'i ddileu",
  "unableToDeleteAccount": "Nid oedd modd dileu eich cyfrif, rhowch gynnig arall",
  "bookingDetailsUpdated": "Manylion archeb wedi'u diweddaru",
  "addStopError": "Methu ychwanegu stop",
  "editStopError": "Methu golygu stop",
  "removeStopError": "Methu tynnu stop",
  "locationError": "Methu cael lleoliad",
  "defaultAddressError": "Methu cael y cyfeiriad diofyn",
  "delayError": "Methu cael oedi'r archeb",
  "unableToCompletePayment": "Nid oedd modd cwblhau eich taliad, rhowch gynnig arall",
  "unableToProceedBooking": "Nid oedd modd parhau â'r archeb hon, rhowch gynnig arall",
  "unableToAddCard": "Nid oedd modd ychwanegu eich cerdyn, rhowch gynnig arall",
  "unableToDeleteCard": "Nid oedd modd dileu eich cerdyn, rhowch gynnig arall",
  "unableToDefaultCard": "Nid oedd modd gosod eich cerdyn diofyn, rhowch gynnig arall",
  "profileUpdated": "Mae eich proffil wedi'i ddiweddaru",
  "editProfileError": "Methu golygu proffil",
  "cardAdded": "Mae eich cerdyn wedi'i ychwanegu",
  "cardDeleted": "Mae eich cerdyn wedi'i ddileu",
  "cardDefaulted": "Mae eich cerdyn diofyn wedi'i ddiweddaru",
  "unableToCancelBooking": "Nid oedd modd canslo'r archeb hon",
  "unableToEditBooking": "Nid oedd modd golygu'r archeb hon",
  "unableToCopyBooking": "Nid oedd modd copïo'r archeb hon",
  "favouriteAdded": "Ffefryn wedi'i ychwanegu",
  "favouriteCleared": "Ffefryn wedi'i glirio",
  "favouriteEdited": "Ffefryn wedi'i olygu",
  "unableToAddFavourite": "Nid oedd modd ychwanegu'r ffefryn hwn",
  "unableToClearFavourite": "Nid oedd modd clirio'r ffefryn hwn",
  "unableToEditFavourite": "Nid oedd modd golygu'r ffefryn hwn",
  "unableToFindBookingTemplate": "Methu dod o hyd i dempled archeb",
  "unableToSearchForAddresses": "Methu chwilio am gyfeiriadau",
  "unableToSearchForContacts": "Methu chwilio am gysylltiadau",
  "unableToSearchForReports": "Methu chwilio am adroddiadau",
  "unableToLoadJourneyDetails": "Methu llwytho manylion y daith",
  "secretKeyCopied": "Allwedd gyfrinachol wedi'i chopïo",
  "contactLink": {
    "contactLinkRequestSent": "Cais cyswllt wedi'i anfon",
    "contactLinkRequestFailed": "Methiant cais cyswllt",
    "unableToLoadLinkedContacts": "Methu llwytho cysylltiadau cysylltiedig",
    "contactLinkAuthorised": "Cyswllt wedi'i awdurdodi",
    "contactLinkRejected": "Cyswllt wedi'i wrthod"
  },
  "jobDetailsCopied": "Manylion swydd wedi'u copïo i'r clipfwrdd",
  "unableToSignOn": "Methu cwblhau mewngofnodi",
  "vouchers": {
    "voucherRemoved": "Taleb {voucherCode} wedi'i thynnu",
    "unableToAddVoucher": "Methu ychwanegu taleb",
    "voucherAdded": "Taleb {voucherCode} wedi'i hychwanegu",
    "voucherAlreadyAdded": "Mae taleb {voucherCode} eisoes wedi'i hychwanegu"
  },
  "unableToOpenFile": "Methu agor {file}",
  "missingFormData": "Data ffurflen ar goll",
  "missingLeadPassengerDetails": "Manylion y prif deithiwr ar goll",
  "quickQuoteUnavailable": "Dyfynbris cyflym ddim ar gael",
  "reporting": {
    "export": {
      "copyMessage": "Adroddiad wedi'i gopïo",
      "error": "Gwall allforio"
    }
  },
  "deviceIntegrityWarning": "Mae'n ymddangos bod y ddyfais hon wedi'i haddasu, a allai roi eich data mewn perygl",
  "newNotification": "Hysbysiad newydd"
}
